import { getElementType, getUnhandledProps, useAccessibility, useStyles, useTelemetry } from '@fluentui/react-bindings';
import * as React from 'react'; // @ts-ignore

import { ThemeContext } from 'react-fela';
import { createShorthandFactory, commonPropTypes } from '../../utils';
import { withSafeTypeForAs } from '../../types';

var ToolbarMenuDivider = function ToolbarMenuDivider(props) {
  var context = React.useContext(ThemeContext);

  var _useTelemetry = useTelemetry(ToolbarMenuDivider.displayName, context.telemetry),
      setStart = _useTelemetry.setStart,
      setEnd = _useTelemetry.setEnd;

  setStart();
  var accessibility = props.accessibility,
      className = props.className,
      design = props.design,
      styles = props.styles,
      variables = props.variables;
  var getA11yProps = useAccessibility(accessibility, {
    debugName: ToolbarMenuDivider.displayName,
    rtl: context.rtl
  });

  var _useStyles = useStyles(ToolbarMenuDivider.displayName, {
    className: ToolbarMenuDivider.className,
    mapPropsToInlineStyles: function mapPropsToInlineStyles() {
      return {
        className: className,
        design: design,
        styles: styles,
        variables: variables
      };
    },
    rtl: context.rtl
  }),
      classes = _useStyles.classes;

  var ElementType = getElementType(props);
  var unhandledProps = getUnhandledProps(ToolbarMenuDivider.handledProps, props);
  var element = React.createElement(ElementType, getA11yProps('root', Object.assign({}, unhandledProps, {
    className: classes.root
  })));
  setEnd();
  return element;
};

ToolbarMenuDivider.className = 'ui-toolbar__menudivider';
ToolbarMenuDivider.displayName = 'ToolbarMenuDivider';
ToolbarMenuDivider.propTypes = commonPropTypes.createCommon();
ToolbarMenuDivider.defaultProps = {
  as: 'li'
};
ToolbarMenuDivider.handledProps = Object.keys(ToolbarMenuDivider.propTypes);
ToolbarMenuDivider.create = createShorthandFactory({
  Component: ToolbarMenuDivider,
  mappedProp: 'content'
});
/**
 * A ToolbarMenuDivider adds non-actionable separator between items of ToolbarMenu.
 */

export default withSafeTypeForAs(ToolbarMenuDivider);